var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover",
          value: {
            disabled: !_vm.title,
            title: _vm.title,
            placement: _vm.tooltipPlacement,
          },
          expression:
            "{ disabled: !title, title, placement: tooltipPlacement }",
          modifiers: { hover: true },
        },
      ],
      staticClass:
        "ml-2 d-inline-flex align-items-center justify-content-center",
    },
    [
      _vm.loading
        ? _c("b-button", { staticClass: "ml-1 py-1 btn-primary" }, [
            _c("i", {
              staticClass: "ld ld-ring ld-spin-fast mini",
              staticStyle: {
                width: "1em !important",
                height: "1em !important",
                "font-size": "0.9em !important",
                color: "white",
              },
            }),
          ])
        : _c(
            "b-button",
            {
              staticClass: "ml-1 py-1 btn-primary",
              on: { click: _vm.handleRefresh },
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$t("filogix.expertSync.retry")) + "\n    "
              ),
              _c("i", {
                staticClass: "fa fa-refresh ml-2",
                staticStyle: { "font-size": "1em" },
              }),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }